(() => {
  if (window.__themeZendeskWidget) return;
  window.__themeZendeskWidget = true;

  // This account uses Web Widget (Classic). Preserve existing account settings.
  const settings = (window.zESettings = window.zESettings || {});
  const widget = (settings.webWidget = settings.webWidget || {});
  widget.zIndex = 2147483647;
  widget.position = Object.assign({}, widget.position, { horizontal: 'right', vertical: 'bottom' });
  const offset = (widget.offset = widget.offset || {});
  const mobileOffset = (offset.mobile = offset.mobile || {});
  const baseVertical = offset.vertical || '12px';
  const baseMobileVertical = mobileOffset.vertical || baseVertical;

  let cart;
  let launcher;
  let open = false;
  let ready = false;
  let lastOffset;
  const resizeObserver = new ResizeObserver(() => updateOffset());
  const visibilityObserver = new MutationObserver(() => updateOffset());
  const launcherResizeObserver = new ResizeObserver(() => {
    reserveLauncherSpace();
    updateOffset();
  });

  function reserveLauncherSpace() {
    if (!launcher || !launcher.offsetWidth) return;
    const style = getComputedStyle(launcher);
    // Match the purchase button's 16px left inset with a 16px gap to Help.
    // The iframe's left margin is outside its visible button and is not reserved twice.
    const space = launcher.offsetWidth + (parseFloat(style.marginRight) || 0)
      + (parseFloat(style.right) || 0) + 16;
    document.documentElement.style.setProperty('--zendesk-launcher-space', `${Math.ceil(space)}px`);
  }

  function observeLauncher() {
    const element = document.getElementById('launcher');
    if (!element || element === launcher) return;
    launcherResizeObserver.disconnect();
    launcher = element;
    launcherResizeObserver.observe(launcher);
    reserveLauncherSpace();
    updateOffset();
  }

  // Classic inserts its launcher asynchronously after the snippet has loaded.
  new MutationObserver(observeLauncher).observe(document.body, { childList: true });
  window.addEventListener('resize', reserveLauncherSpace);

  function updateOffset(force = false) {
    // Center the launcher in the entire white purchase bar. Classic adds an
    // iframe bottom margin, which must be subtracted from its configured offset.
    const visible = cart && cart.classList.contains('is-visible');
    const height = visible && open ? cart.offsetHeight : 0;
    let vertical = height ? `${(parseFloat(baseVertical) || 0) + height}px` : baseVertical;
    let mobileVertical = height ? `${(parseFloat(baseMobileVertical) || 0) + height}px` : baseMobileVertical;
    if (visible && !open && launcher && launcher.offsetHeight) {
      const marginBottom = parseFloat(getComputedStyle(launcher).marginBottom) || 0;
      const centered = (cart.offsetHeight - launcher.offsetHeight) / 2 - marginBottom;
      vertical = mobileVertical = `${centered}px`;
    }
    const nextOffset = `${vertical}/${mobileVertical}`;
    if (!force && nextOffset === lastOffset) return;
    lastOffset = nextOffset;
    offset.vertical = vertical;
    mobileOffset.vertical = mobileVertical;
    document.documentElement.style.setProperty(
      '--zendesk-widget-bottom-space',
      `${Math.max(parseFloat(offset.vertical) || 0, parseFloat(mobileOffset.vertical) || 0)}px`
    );

    if (ready) {
      window.zE('webWidget', 'updateSettings', {
        webWidget: {
          zIndex: widget.zIndex,
          position: widget.position,
          offset: { vertical: offset.vertical, mobile: { vertical: mobileOffset.vertical } },
        },
      });
    }
  }

  function observeCart() {
    resizeObserver.disconnect();
    visibilityObserver.disconnect();
    cart = document.querySelector('.js-floating-cart');
    if (cart) {
      cart.classList.add('has-zendesk');
      resizeObserver.observe(cart);
      visibilityObserver.observe(cart, { attributes: true, attributeFilter: ['class'] });
    }
    updateOffset(true);
  }

  observeCart();
  document.addEventListener('shopify:section:load', observeCart);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(observeCart));

  function onLoad() {
    if (typeof window.zE !== 'function') return;
    window.zE(() => {
      ready = true;
      window.zE('webWidget:on', 'open', () => {
        open = true;
        updateOffset(true);
      });
      window.zE('webWidget:on', 'close', () => {
        open = false;
        updateOffset(true);
      });
      observeLauncher();
      updateOffset(true);
    });
  }

  // App embeds may already have inserted the snippet via content_for_header.
  const existing = document.querySelector('#ze-snippet, script[src*="static.zdassets.com/ekr/snippet.js"]');
  if (existing) {
    if (typeof window.zE === 'function') onLoad();
    else existing.addEventListener('load', onLoad, { once: true });
    return;
  }

  // Start of 33taiyo Zendesk Widget script
  const snippet = document.createElement('script');
  snippet.id = 'ze-snippet';
  snippet.src = 'https://static.zdassets.com/ekr/snippet.js?key=f191f7c5-ef2f-4d66-a315-abc01301df3c';
  snippet.async = true;
  snippet.addEventListener('load', onLoad, { once: true });
  document.body.appendChild(snippet);
  // End of 33taiyo Zendesk Widget script
})();
